/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface TreeMapData
 */
export interface TreeMapData {
  /**
   *
   * @type {string}
   * @memberof TreeMapData
   */
  readonly riskIndicator: string;
  /**
   *
   * @type {string}
   * @memberof TreeMapData
   */
  readonly metric: string;
  /**
   *
   * @type {number}
   * @memberof TreeMapData
   */
  risk: number;
  /**
   *
   * @type {number}
   * @memberof TreeMapData
   */
  weightedRisk: number;
  /**
   *
   * @type {number}
   * @memberof TreeMapData
   */
  contribution: number;
  /**
   *
   * @type {number}
   * @memberof TreeMapData
   */
  unweightedRisk: number;
}

/**
 * Check if a given object implements the TreeMapData interface.
 */
export function instanceOfTreeMapData(value: object): value is TreeMapData {
  if (!('riskIndicator' in value) || value['riskIndicator'] === undefined) return false;
  if (!('metric' in value) || value['metric'] === undefined) return false;
  if (!('risk' in value) || value['risk'] === undefined) return false;
  if (!('weightedRisk' in value) || value['weightedRisk'] === undefined) return false;
  if (!('contribution' in value) || value['contribution'] === undefined) return false;
  if (!('unweightedRisk' in value) || value['unweightedRisk'] === undefined) return false;
  return true;
}

export function TreeMapDataFromJSON(json: any): TreeMapData {
  return TreeMapDataFromJSONTyped(json, false);
}

export function TreeMapDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): TreeMapData {
  if (json == null) {
    return json;
  }
  return {
    riskIndicator: json['risk_indicator'],
    metric: json['metric'],
    risk: json['risk'],
    weightedRisk: json['weighted_risk'],
    contribution: json['contribution'],
    unweightedRisk: json['unweighted_risk'],
  };
}

export function TreeMapDataToJSON(value?: Omit<TreeMapData, 'riskIndicator' | 'metric'> | null): any {
  if (value == null) {
    return value;
  }
  return {
    risk: value['risk'],
    weighted_risk: value['weightedRisk'],
    contribution: value['contribution'],
    unweighted_risk: value['unweightedRisk'],
  };
}
